// extracted by mini-css-extract-plugin
export default {"localeSelector":"DestinationEditorPage_localeSelector__LVjEA","headerExtra":"DestinationEditorPage_headerExtra__q3BY3","title":"DestinationEditorPage_title__j03rA"};